import { COLOR_KEYS } from '../../../constants';
import { VideoSectionProps } from './VideoSection';

export const DEFAULT_VALUES: VideoSectionProps = {
  heading: 'Example heading',
  backgroundColor: COLOR_KEYS.moss,
  wistiaId: 't1yil0mi2f',
};
